export function fieldRequiredMessage(name: string) {
  return `${name} required`
}

export function fieldIncorrectFormatMessage(name: string) {
  return `Valid ${name.toLowerCase()} required`
}
